import { Model } from '@nozbe/watermelondb'
import { field, date } from '@nozbe/watermelondb/decorators'
import { toRaw } from './utils';

export const TradeColumns = [
    { name: 'trade_type_default_id', type: 'number' },
    { name: 'realm_id', type: 'number' },
    { name: 'name', type: 'string' },
    { name: 'enabled', type: 'number' },
    { name: 'client_key', type: 'string', isOptional: true },
    { name: 'created_at', type: 'number' },
    { name: 'updated_at', type: 'number' },
]

export class TradeType extends Model {
    static table = 'tradeType'
    
    @field('trade_type_default_id') tradeTypeDefaultId
    @field('realm_id') realmId
    @field('name') name
    @field('enabled') enabled
    @field('client_key') clientKey
    @date('created_at') createdAt
    @date('updated_at') updatedAt

    toRaw = toRaw.bind(this, TradeColumns)
}